import { createContext, useState, useEffect } from "react";
import { getStorageJSON } from "../../../utils/helpers";

export const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const data = getStorageJSON("cart", []);
    setCart(Array.isArray(data) ? data : []);

    const syncCart = () => {
      const latest = getStorageJSON("cart", []);
      setCart(Array.isArray(latest) ? latest : []);
    };

    window.addEventListener("storage", syncCart);
    window.addEventListener("cart-updated", syncCart);

    return () => {
      window.removeEventListener("storage", syncCart);
      window.removeEventListener("cart-updated", syncCart);
    };
  }, []);

  const updateCart = (newCart) => {
    setCart(newCart);
    localStorage.setItem("cart", JSON.stringify(newCart));
    window.dispatchEvent(new Event("cart-updated"));
  };

  return (
    <CartContext.Provider value={{ cart, updateCart }}>
      {children}
    </CartContext.Provider>
  );
}